import React from 'react';
import { FlatList, Platform, StyleSheet, } from 'react-native';
import { ListItem } from '@annunciate/ui/dist/components/list/ListItem';
export const SeriesFlatlist = ({ items, onEndReached, listItemContainerStyle, ListHeaderComponent, }) => {
    const renderItem = ({ item: { item }, }) => {
        const isLoading = item.id === undefined;
        return (React.createElement(ListItem, { item: item, isLoading: isLoading, listItemContainerStyle: listItemContainerStyle }));
    };
    return (React.createElement(FlatList, { keyExtractor: (item, index) => `${item.id}-${index}`, data: items, renderItem: renderItem, onEndReached: onEndReached, onEndReachedThreshold: 0.5, onScrollToIndexFailed: () => { }, style: styles.flatlist, ListHeaderComponent: ListHeaderComponent }));
};
const styles = StyleSheet.create({
    flatlist: Platform.select({
        web: {
            height: 'calc(100vh - var(--nav-bar-height) - var(--mini-player-height))',
            maxHeight: '100vh',
        },
        default: {},
    })
});
//# sourceMappingURL=SeriesFlatlist.js.map